import React from 'react';
import { Link } from 'react-router-dom';
import Page from 'structure/page';
import styled from 'react-emotion';

const HomePage = styled(Page)({
  textAlign: 'center',
}, ({ theme }) => ({
  text: theme.page.textColor,
}));

const P = styled('p')({
  margin: 0,
  textAlign: 'center',
});

const Before = () => (<P>
    At Creative Corsetry we are comitted to working with you to achieve the
    look and style that is tailored specifically to meet your needs and wishes
  </P>
);

const After = () => (
  <P>
    <Link to='/store'>Browse</Link> our selection of designs and materials
    and <Link to='/about'>contact us</Link> to
    commission a truly <Link to='/commission'>personalized corset.</Link>
  </P>
);

export const Home = (props) => (
  <HomePage {...props} title='Home' noPanel before={Before} after={After} />
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home/home.js